import Axios from 'axios';
import {
  FetchAllEmployeesResult,
  FetchBranchResult,
  FetchEmployeeResult,
  FetchAllBranchesResult,
  FetchEmployeesResult
} from './types';
import appConfig from './config';
import { tracking, theme } from '@wco/toolkit';

export async function fetchAllEmployeesForBranch(
  input: string
): Promise<FetchAllEmployeesResult> {
  const empForBranch: Promise<FetchAllEmployeesResult> = Axios.get(
    `${appConfig.apiBasePath}/fmi/employees`,
    {
      headers: { bankno: theme.bankId },
      params: { branchname: input }
    }
  ).then((res: any) => {
    return res.data;
  });

  if (!empForBranch) {
    throw new Error('Cannot fetch employees');
  }

  return empForBranch;
}

export async function fetchBranch(input: string): Promise<FetchBranchResult> {
  const branch: Promise<FetchBranchResult> = Axios.get(
    `${appConfig.apiBasePath}/fmi/branch`,
    {
      headers: { bankno: theme.bankId },
      params: { branchname: input }
    }
  ).then((res: any) => {
    if (!res.data.branchName) {
      throw new Error(res.data.detail);
    }
    return res.data;
  });

  return branch;
}

export async function fetchAllBranches(): Promise<FetchAllBranchesResult> {
  const branches: Promise<FetchAllBranchesResult> = Axios.get(
    `${appConfig.apiBasePath}/fmi/branches`,
    {
      headers: { bankno: theme.bankId }
    }
  ).then((res: any) => {
    if (!res.data.branches) {
      throw new Error('Branches does not exist');
    }
    return res.data;
  });

  return branches;
}

export async function fetchEmployeeByName(
  input: string
): Promise<FetchEmployeesResult | null> {
  let empSearchResults: Promise<FetchEmployeesResult> | null = null;

  if (input.length > 2) {
    empSearchResults = Axios.get(
      `${appConfig.apiBasePath}/fmi/employeesearch`,
      {
        headers: { bankno: theme.bankId },
        params: { searchtext: input }
      }
    ).then((res: any) => {
      tracking.trackEvent('Search', 'Found');
      if (!empSearchResults || !res.data.employees) {
        tracking.trackEvent('Search', 'Not Found');
        throw new Error(res.data.detail);
      }
      return res.data;
    });
  }

  return empSearchResults;
}

export async function fetchEmployee(
  userId: string,
  branchName: string
): Promise<FetchEmployeeResult> {
  const employeeResult: Promise<FetchEmployeeResult> = Axios.get(
    `${appConfig.apiBasePath}/fmi/employee`,
    {
      headers: { bankno: theme.bankId },
      params: {
        branchname: branchName,
        userid: userId
      }
    }
  ).then((res: any) => {
    if (!res.data) {
      throw new Error('Employee does not exist');
    }
    return res.data;
  });

  return employeeResult;
}
